<template>
  <div>

    <FiltersProcesos :sinMsp="sinMsp" />

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">

        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table v-if="itemspro.length > 0" striped responsive :per-page="table.pageSize" :items="itemspro"
            :fields="fieldsTable" sort-by.sync="" sort-desc.sync=false sort-direction="asc" size="sm">
            <template #cell(acciones)="data">

              <div class="row">
                <div class="d-flex p-0">
                  <b-button v-if="data.item.estadoProceso === 'ejecutada'"
                    @click="showModalReposo(data.item.paciente, data.item.procedimiento, data.item.medicoRealiza, data.item.token)"
                    title="mostrar modal reposo/asistencia" size="sm" variant="primary">
                    <i class="fa-solid fa-bed"></i>
                  </b-button>

                  <b-button
                    @click="showModalPreAnestesico(data.item.paciente, data.item.procedimiento, data.item, data.item.medicoRealiza, data.item.token)"
                    title="Formulario Pre Anestesico 018" size="sm" variant="primary">
                    <i class="fa-regular fa-rectangle-list"></i>
                  </b-button>

                  <b-button v-if="canProgramme" :variant="data.item.estadoProceso === 'creada' ? 'primary' : 'warning'"
                    size="sm" @click="showModalFecha(data.item)" title="Fecha de programacion">
                    <i class="fas fa-calendar font-weight-bold" style="color: white" />
                  </b-button>
                  <b-button v-if="data.item.cobertura !== 'PARTICULAR'" title="Subir calificas"
                    @click="onShowModalMSP(data.item.token)" variant="primary" size="sm">
                    <i class="fa-solid fa-up-long font-weight-bolder"></i>
                  </b-button>

                  <b-button v-if="data.item.estadoProceso === 'programada' || data.item.estadoProceso === 'ejecutada'"
                    :title="data.item.estadoProceso === 'programada' ? 'Ejecutar procedimiento' : 'Cambiar ejecutado por programado'"
                    @click="ejecutarProceso(data.item.token, data.item.estadoProceso, data.item.medicoRealiza, data.item.codigo)"
                    :variant="data.item.estadoProceso === 'programada' ? 'success' : 'warning'" size="sm">
                    <i v-if="data.item.estadoProceso === 'programada'" class="fa-solid fa-check font-weight-bolder"></i>
                    <i v-else class="fa-solid fa-clock-rotate-left"></i>

                  </b-button>
                </div>
              </div>


              <!-- <b-button
                  v-if="hasPermission('adm_eliminar_admision')"
                  variant="danger"
                  size="sm"
                  @click="removeItemid(data.item.id)"
                >
                  <font-awesome-icon icon="circle-xmark" style="color: white" />
                </b-button> -->

            </template>

            <!-- <template #cell(cobetura)="data">
              <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.procedimiento">
                {{ data.item.procedimiento.split(" ").slice(0, 4).join(" ") + "..."}}
              </div>
            </template> -->

            <template #cell(procedimiento)="data">
              <div :id="'tooltip-target-' + data.index" v-b-tooltip.hover :title="data.item.procedimiento">
                {{ data.item.procedimiento.split(" ").slice(0, 4).join(" ") + "..." }}
              </div>
            </template>

            <template #cell(informes)="data">
              <div class="d-flex p-0">
                <b-button size="md" variant="warning" title="Ver Formularios"
                  @click="onViewForms(data.item.token, data.item)">
                  <i class="fa-solid fa-folder-open font-weight-lighter" />
                </b-button>
                <b-button size="sm" variant="primary" title="Descargar pre anestesico"
                  @click="downloadPreAnestesico(data.item.id)">
                  <i class="fa-solid fa-circle-down font-weight-lighter" />
                </b-button>
                <b-button 
                  v-if="showActaProcesoClinico"
                  size="sm" 
                  variant="primary" 
                  class="ml-1"
                  title="Acta Servicio" 
                  @click="downloadActaProcesoClinico(data.item)"
                >
                  <i class="fa-solid fa-i"/>
                </b-button>
              </div>
              <!-- <b-button 
                variant="warning" 
                size="sm" 
                title="Descargar Informes"
                @click="descargarZipInformes(data.item.id, data.item.paciente)">
                <i class="fa-solid fa-folder-closed"/>

              </b-button>

              <b-button 
                v-b-tooltip.hover title="Descargar formulario 013A"
                v-if="data.item.estadoProceso === 'Resultado'" variant="warning" size="sm"
                @click="formulario013A(data.item.id)">
                <i class="fas fa-file-download" style="color: white"></i>
              </b-button> -->
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-pagination v-if="itemspro.length > 0" v-model="table.page" :total-rows="table.totalRows" first-number
          last-number :small="true" class="mb-0" align="center" prev-class="prev-item" next-class="next-item"
          @change="cambiarPagina">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>

      </b-card>

    </b-overlay>


    <ProgramarFecha v-if="canProgramme" />

    <ViewFormsProcesos v-if="showViewFormsProcesos" :tokenProceso="tokenProceso" :dataProc="dataProc" />

    <LoadMsp />

    <b-modal id="modal-ejecutar" hide-footer>
      <div class="text-success">
        <span>Medico que realiza el procedimietno:</span>
        <b-row class="my-2">

          <b-col>
            <SearchOpts v-model="medicoRealiza" :searchService="doctoresService.searchDoctoresByTermSelect"
              :minChars="3" :placeholder="'Buscar medico...'" />
          </b-col>

        </b-row>
        <b-row>
          <b-col class="text-center p-4 m-4">
            <b-button v-if="estadoProceso === 'programada'" @click="onClickEjecutarProcedimiento('e')" class="p-2"
              title="ejecutar procedimiento" size="xl" variant="success">
              <div>
                <i class="fa-regular fa-circle-check fa-3x font-weight-lighter"></i>
              </div>
              <div class="mt-2">
                <h4 class="text-white">Ejecutar Procedimiento</h4>
              </div>

            </b-button>
            <b-row>
              <b-col v-if="canChangeToProgramado" class="mb-1">
                <b-button v-if="estadoProceso === 'ejecutada'" @click="onClickEjecutarProcedimiento('c')" class="p-2"
                  title="cambiar a programada" size="sm" variant="warning">
                  <div>
                    <i class="fa-solid fa-2x fa-clock-rotate-left"></i>
                  </div>
                  <div class="mt-2">
                    <h4 class="text-white">Reestablecer estado a programado</h4>
                  </div>

                </b-button>
              </b-col>
              <b-col>
                <b-button v-if="estadoProceso === 'ejecutada'" @click="onClickEjecutarProcedimiento('e')" class="p-2"
                  title="cambiar medico" size="sm" variant="success">
                  <div>
                    <i class="fa-solid fa-people-arrows fa-2x "></i>
                  </div>
                  <div class="mt-2">
                    <h4 class="text-white">Mantener estado y cambiar médico</h4>
                  </div>

                </b-button>
              </b-col>

            </b-row>


          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal size="lg" id="modal-formulario-reposo" title="DESCANSO MEDICO/ASISTENCIA" hide-footer>
      <FormularioReposoAsistencia :medicoRealiza="medicoRealiza" :paciente="paciente" :procedimiento="procedimientoItem"
        :tokenProceso="procesoToken" />
    </b-modal>

    <b-modal id="ver-preanestesico" size="xl" hide-footer>
      <Formulario018PreAnestesico :procedimiento="procedimientoItem" :tokenProceso="procesoToken"
        :procedimientoObject="procedimientoObject" />
    </b-modal>

  </div>
</template>
<script>
import { comprobarPermisos } from "@/shared/helpers";
import { comprobarRoles } from "../../../shared/helpers";
import rutas from "@/assets/utils/rutas.json";
import { mapState } from "vuex";
import { SearchOpts } from "../../../shared/components";

import { BootstrapVue } from 'bootstrap-vue';


import axios from "axios";
import "flatpickr/dist/flatpickr.css";
import actions from "@/assets/utils/utils";
import { fileService } from "@/shared/services";

import { FiltersProcesos, ProgramarFecha, ViewFormsProcesos, LoadMsp } from "../components";
import { procedimientosService } from "../services/procedimientosService";
import { faTruckMedical } from "@fortawesome/free-solid-svg-icons";
import { doctoresService } from "../../../shared/services";
import FormularioReposoAsistencia from "../components/Formularios/FormularioReposoAsistencia.vue";
import Formulario018PreAnestesico from "../components/Formularios/Formulario018PreAnestesico.vue";
import { procedimientosFormulariosService } from "../services";
import { ROLES } from "../../../shared/constants";
import { validacionFormsObligatorios } from "../constants/fomulariosObligatorios";



export default {

  components: {
    ...BootstrapVue.components,

    ProgramarFecha,

    FiltersProcesos,
    ViewFormsProcesos,
    LoadMsp,
    SearchOpts,
    FormularioReposoAsistencia,
    Formulario018PreAnestesico
  },


  data() {
    return {
      codigoProcedimiento: null,
      dataProc: {
        procedimiento: null,
        paciente: null,
        fechaProgramada: null,
        estado: null
      },
      sinMsp: null,
      doctoresService,
      procesoToken: null,
      paciente: null,
      procedimientoItem: null,
      estadoProceso: null,
      medicoRealiza: null,
      modalEjecutarIsShow: false,
      tokenProceso: null,
      viewForms: false,
      filters: null,
      showViewFormsProcesos: false,

      idPaciente: null,
      tableAdmMed: null,
      consInformado: null,
      tipoFecha: "1",


      idsformprocs: {
        f005: null,
        f060: null,
        f024: null,
        f022: null,
        f020: null,
        f012b: null,
        f006: null,
        f013a: null
      },

      proccitaid: null,

      diag: "",
      idP: 0,
      capturedImages: [],
      importacion: false,
      bloqueo_boton: false,
      files: [],
      mostrarLoader: false,
      value: 0,
      diagnosticos: [],
      establecimiento: null,
      isLoading: false,
      estado: null,
      opsDiagnosticos: [],
      informe: null,
      especialidad: null,
      fechaEjecucion: null,
      idProceso: null,

      listaAcciones: [],
      procedimientoObject: null,


      table: {
        page: 1,
        pageSize: 20,
        totalRows: 50
      },


      fieldsTable: [

        {
          key: "paciente",
          label: "Paciente",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fechaprog",
          label: "Fecha Prog",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fechaaten",
          label: "Fecha Atencion",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "procedimiento",
          label: "Procedimiento",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "tipoCobertura",
          label: "Cobertura",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "especialidad",
          label: "Especialidad",
          sortable: true,
          thClass: "text-center",
        },

        {
          key: "doctor",
          label: "Doctor",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "estadoProceso",
          label: "Estado",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "msp",
          label: "Msp",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "informes",
          label: "informes",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],

      itemspro: [],

    };
  },


  computed: {
    canProgramme() {
      return comprobarRoles([ROLES.AGENDAMIENTO])
    },
    canChangeToProgramado() {
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES])
    },
    canExecute() {
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.DOCTOR])
    },
    showActaProcesoClinico() {
      return comprobarRoles([
        ROLES.ADMISION,
        ROLES.JEFE_MEDICO,
        ROLES.ADMINISTRADOR,
        ROLES.AGENDAMIENTO,
        ROLES.AUX_LABORATORIO,
        ROLES.LABORATORIO,
      ]);
    },
    ...mapState({
      stFilterProcesos: state => state.generals.filterProcesos,
    }),
  },


  created() {
    comprobarPermisos(this.$route);
    // this.loadDataTable();
    this.setToken();
    // Solo limpiar si hay query params en la URL
    if (Object.keys(this.$route.query).length > 0) {
      this.$router.replace({ path: this.$route.path });
    }


  },


  mounted() {
    actions.setearTitulo("Procedimiento Clinico");
  },


  methods: {
    async downloadPreAnestesico(idProc) {
      const blobPdf = await procedimientosFormulariosService.generar018PreProc(idProc)
      actions.cargarArchivos(blobPdf, "018 PRE-ANESTESICO.pdf", "data:application/pdf;base64")

    },
    async downloadActaProcesoClinico(item) {
      const idCita = item?.idCita;

      if (!idCita) {
        this.$swal({
          title: "Acta no disponible",
          text: "No se pudo identificar la cita asociada al procedimiento.",
          icon: "warning",
          confirmButtonColor: "#089599",
        });
        return;
      }

      const query = `                
       query qrGetDocumentActa($idCita: String!, $servicio : String) {
          getDocumentActa(idCita: $idCita, servicio: $servicio) {
            status
            message
            citaPdf
            cita{
              id
              fechaCita
              horaCita
              paciente{
                persona{
                  primerNombre
                  primerApellido
                  identificacion
                }
              }
            }
          }
        }
      `;

      const variables = {
        idCita,
        servicio: 'PROCESO_CLINICO'
      };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.status === 200) {
          const pdfBase64 = response.data.data.getDocumentActa.citaPdf;
          actions.cargarArchivos(pdfBase64, `acta_${idCita}.pdf`, "data:application/pdf;base64");
        }
      } catch (error) {
        console.error("Error al descargar el acta de proceso clínico:", error);
        this.$swal({
          title: "Error",
          text: "No se pudo descargar el acta del procedimiento clínico.",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },
    showModalPreAnestesico(paciente, procedimiento, procedimientoObject, medicoRealiza, tokenProceso) {
      this.paciente = paciente
      this.medicoRealiza = medicoRealiza
      this.procedimientoObject = procedimientoObject
      this.procedimientoItem = procedimiento
      this.procesoToken = tokenProceso
      this.$bvModal.show('ver-preanestesico')
    },


    async onClickEjecutarProcedimiento(accion) {

      //  let text_html = `<h2>Formularios por llenar:</h2><br> <ul><li>Form 003 </li> <li>Form 005 </li>  <li>Form 007 </li>  </ul>`
      //   this.$swal.fire({
      //     title: "Llenar Formularios",
      //     html: text_html,
      //     icon: "warning",

      //   });
      //   return

      if (!this.medicoRealiza && accion === 'e') {
        this.$swal.fire({
          title: "Seleccione medico",
          text: "Debe seleccionar el medico que realiza el procedimiento",
          icon: "warning",

        });
        return
      }
      let textPregunta = accion === 'e' ? 'ejecutar el procedimiento?' : 'cambiar a programado?'
      let textConfirmacion = accion === 'e' ? 'ejecutó el procedimiento!' : 'cambió a programado!'

      const result = await this.$swal({
        title: `¿Está seguro de ${textPregunta}`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "Aún no",
      });

      if (!result.isConfirmed) return;
      let cods_no_obligatorios = validacionFormsObligatorios.noObligatorios
      let formsRequeridos = validacionFormsObligatorios.idsFormsTodos
      const response = await procedimientosFormulariosService.getByProceso(this.tokenProceso);
      let formsNoEncontrados = []
       let formsLlenados = []
        
        let existe12b = false
       let data = response?.data
       data.forEach(e => {
          let entro = 0
          formsLlenados.push(e.idFormulario)
          if ((e.idFormulario === '12b' || e.idFormulario === '12bNormal') && entro === 0 ){
              entro = 1
              existe12b = true

          }
        });
      if (accion === 'e' && !cods_no_obligatorios.includes(this.codigoProcedimiento)) {
        // Verificar todos los formularios obligatorios para este procedimiento
        formsRequeridos.forEach(elementRequired => {
          if (!formsLlenados.includes(elementRequired.codigo)) {
            formsNoEncontrados.push(elementRequired)
          }
        })

        // Validar existencia del 12B (o 12B normalizado)
        if (!existe12b) {
          formsNoEncontrados.push({ codigo: '12b', text: 'FORMULARIO 12B' })
        }

        // Solo bloquear si realmente faltan formularios
        if (formsNoEncontrados.length > 0) {
          await this.$swal.fire({
            title: 'Formularios faltantes',
            html: `
              <p>Para ejecutar este procedimiento requiere el llenado de estos formularios:</p>
              <ul>
                ${formsNoEncontrados.map(form => `<li>${form.text}</li>`).join('')}
              </ul>
            `,
            icon: 'error'
          })

          console.log('idsFormularios no llenados', formsNoEncontrados)
          return
        }
      }
      if(!existe12b && cods_no_obligatorios.includes(this.codigoProcedimiento) ){
            await this.$swal.fire({
        title: "Debe llenar form 12b.",
        text: `No puede ejecutar sin haber llenado el formulario 12b`,
        icon: "error"
      })
      return
        }

      const execResp = await procedimientosService.ejecutarProcesoByToken(this.tokenProceso, this.medicoRealiza, accion)
      if (!execResp || execResp.status !== 'success') {
        await this.$swal.fire({
          title: "No se pudo ejecutar",
          text: execResp?.message || 'El servidor no confirmó la ejecución.',
          icon: "error"
        })
        return
      }
      await this.$swal.fire({
        title: "Confirmado.",
        text: `Se ${textConfirmacion}`,
        icon: "success"
      })

      this.$router.go(0)
    },
    async ejecutarProceso(tokenProceso, estadoProceso, medicoRealiza, codigo) {
      this.medicoRealiza = medicoRealiza
      this.tokenProceso = tokenProceso
      this.estadoProceso = estadoProceso
      this.codigoProcedimiento = codigo

      this.$bvModal.show("modal-ejecutar");


    },
    async showModalReposo(paciente, procedimiento, medicoRealiza, tokenProceso) {
      this.paciente = paciente
      this.medicoRealiza = medicoRealiza
      this.procedimientoItem = procedimiento
      this.procesoToken = tokenProceso
      this.$bvModal.show("modal-formulario-reposo");


    },

    canViewBtn(codigo, nameButton) {

      // return (dataForms[codigo]) 
      //   ? dataForms[codigo].includes(nameButton)
      //   : false;

      return true

    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },



    async guardarInforme() {
      let dataForm = localStorage.getItem("jsonInformeColpos");

      if (!dataForm || dataForm === "[]" || dataForm === "") {
        await this.$swal.fire({
          icon: "warning",
          text: "No se guardó, data inexistente.",
        });
        return;
      }
      dataForm = JSON.parse(dataForm)
      const files = dataForm.msps;
      let urlMspPaciente = null;
      let urlMspTitular1 = null;
      let urlMspTitular2 = null;
      let urlMspTitular3 = null;

      await Promise.all(
        Object.keys(files).map(async (key) => {
          const fileGroup = files[key];

          if (!fileGroup) return;

          const dataField = key === 'mspPaciente'
            ? dataForm?.url_msp_paciente
            : key === 'mspTitular1'
              ? dataForm?.url_msp_titular1
              : key === 'mspTitular2'
                ? dataForm?.url_msp_titular2
                : key === 'mspTitular3'
                  ? dataForm?.url_msp_titular3
                  : null;


          let dataFieldObj = null;

          try {
            dataFieldObj = JSON.parse(dataField);
          } catch (error) {
            dataFieldObj = {
              identificacion: '1111111111',
              urls: { "1": dataField }
            };
          }

          const objectFile = {
            identificacion: fileGroup.identificacion,
            urls: dataFieldObj?.urls || {},
          }

          if (fileGroup.newMsp)
            objectFile.urls["1"] = await fileService.upload('msp', fileGroup.newMsp, `${fileGroup.identificacion}`);

          if (fileGroup.newMsp2)
            objectFile.urls["2"] = await fileService.upload('msp', fileGroup.newMsp2, `${fileGroup.identificacion}`);

          if (key === 'mspPaciente')
            urlMspPaciente = JSON.stringify(objectFile);

          if (key === 'mspTitular1')
            urlMspTitular1 = JSON.stringify(objectFile);

          if (key === 'mspTitular2')
            urlMspTitular2 = JSON.stringify(objectFile);

          if (key === 'mspTitular3')
            urlMspTitular3 = JSON.stringify(objectFile);

        })
      );

      dataForm = {
        ...dataForm, url_msp_paciente: urlMspPaciente,
        url_msp_titular1: urlMspTitular1,
        url_msp_titular2: urlMspTitular2,
        url_msp_titular3: urlMspTitular3,
      }


      dataForm = JSON.stringify(dataForm)
      if (dataForm) {
        const query = `
          mutation MyMutation(
            $idFormulario: String!, 
            $jsonData: String!, 
            $procId: ID!, 
            $idFormExistente: ID
          ) {
            saveDataFormProc(
              idFormulario    : $idFormulario, 
              jsonData        : $jsonData, 
              procId          : $procId, 
              idFormExistente : $idFormExistente
            ) {
              message
              status
            }
          }`;

        try {
          const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
              idFormulario: "012b",
              jsonData: dataForm,
              procId: this.proccitaid,
              idFormExistente: this.idsformprocs.f012b,
            },
          });


          if ((response.data.data.saveDataFormProc.status = "Success")) {
            await this.$swal.fire({
              icon: "success",
              text: "Guardado correctamente",
            });
            this.$router.go(0);
          } else {
            this.$swal({
              title: "Error",
              text: "No se guardo! Contacte al equipo de desarrollo",
              icon: "error",
              confirmButtonColor: "#089599",
            });
          }
        } catch (error) {
          console.log("este es el error", error)
          this.$swal({
            title: "Error",
            text: "Error al guardar la informacion",
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      }
    },



    async descargarZipInformes(id, paciente = '') {
      const query = `
        query MyQuery($idproc: ID!) {
          generateInformesZipPdf(idproc: $idproc) {                       
            message
            pdfBase64
            nameFile
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: {
            idproc: id,
          },
        });

        if ((response.data.data.generateInformesZipPdf && response.data.data.generateInformesZipPdf.length)) {

          let arregloRespuesta = response.data.data.generateInformesZipPdf

          actions.generateZipInformes(arregloRespuesta, paciente)


        } else {
          this.$swal({
            title: "Error",
            text: "El archivo no existe, comunicar con el adminsitrador sistema",
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },


    procedimientoMedicamento(idProceso) {
      if (idProceso) {
        this.idProceso = idProceso;
        this.idP = idProceso;

        this.$bvModal.show("modal-proceso-medicamento");
      }
    },


    cambiarPagina(value) {
      this.table.page = value;
      this.loadDataTable();
    },



    async loadDataTable() {

      const params = {
        ...this.filters,
        page: this.table.page,
        pageSize: this.table.pageSize,
      }

      const responseProcesos = await procedimientosService.getAll(params);

      if (!responseProcesos) return;

      this.table.totalRows = responseProcesos.total;
      this.sinMsp = responseProcesos.sinMsp

      const procesosMapped = responseProcesos.data.map(item => {

        if (item.consultamedica) {

          let descCobertura = ''
          let cantTitulares = 0
          if (item.consultamedica.cita.detallescitaSet && item.consultamedica.cita.detallescitaSet.length > 0) {
            try {
              let details_not_parsed = item.consultamedica.cita.detallescitaSet[0].detailsSeguro


              let detallescita = JSON.parse(details_not_parsed)
              descCobertura = `- ${detallescita.seguroSalud.code}`
            } catch (error) { console.log("error pareso", error) }

            try {
              let titulares_not_parsed = item.consultamedica.cita.detallescitaSet[0].detallesTitulares
              if (titulares_not_parsed) {
                let detalles_titulares = JSON.parse(titulares_not_parsed)

                let titulares = detalles_titulares ? detalles_titulares : []
                cantTitulares = titulares.length
              }

            } catch (error) { console.log("error pareso titulares", error) }
          }

          const pacientePersona = item.consultamedica.cita.paciente.persona;
          const doctorPersona = item.consultamedica.cita.doctor.idPersona;
          const procedimientoOdonto = `${item.procedimientoOdonto?.codigo} - ${item.procedimientoOdonto?.descripcion}`
          const procedimiento = `${item.procedimiento?.codigo} - ${item.procedimiento?.descripcion}`
          
        let procedimientoName = ""

if (item.procedimientoOdonto?.codigo && item.procedimientoOdonto?.descripcion) {
  procedimientoName = `${item.procedimientoOdonto.codigo} - ${item.procedimientoOdonto.descripcion}`
} else if (item.procedimiento?.codigo && item.procedimiento?.descripcion) {
  procedimientoName = `${item.procedimiento.codigo} - ${item.procedimiento.descripcion}`
} else {
  procedimientoName = ""
}
          let tipoCobertura = item.consultamedica.cita.cobSeleccionada.descripcion || ""
          cantTitulares = cantTitulares + 1

          let mspsSubidos = []
          item.urlMspPaciente && mspsSubidos.push(item.urlMspPaciente)
          item.urlMspTitular1 && mspsSubidos.push(item.urlMspTitular1)
          item.urlMspTitular2 && mspsSubidos.push(item.urlMspTitular2)
          item.urlMspTitular3 && mspsSubidos.push(item.urlMspTitular3)

          let mspSubidos = tipoCobertura !== 'PARTICULAR' ? `Subidos: ${mspsSubidos.length} / ${cantTitulares}` : 'No aplica'
          let medicoRealiza = null
          if (item.doctorRealiza) {
            medicoRealiza = {
              value: item.doctorRealiza.id,
              text: `${item.doctorRealiza.idPersona.primerApellido} ${item.doctorRealiza.idPersona.primerNombre}`,
              especialidad: item.doctorRealiza.especialidad.descripcion
            }
          }
          return {
            id: item.id || "",
            token: item.token || "",
            idCita: item.consultamedica.cita.id,
            fechaprog: item.fechaProgramada ? new Date(item.fechaProgramada).toLocaleString("pt-BR") : "No programada",
            procedimiento: procedimientoName,
            fechaaten: item.consultamedica.cita.fechaCita || " ",
            //establecimiento: item.consultamedica.cita.establecimiento.Descripcion || "",
            codigo: item.procedimiento?.codigo || '',
            idPaciente: item.consultamedica.cita.paciente.id,
            paciente: [pacientePersona?.identificacion, pacientePersona.primerApellido, pacientePersona.segundoApellido, pacientePersona.primerNombre, pacientePersona.segundoNombre].filter(Boolean).join(" ") || "",
            doctor: [doctorPersona.primerNombre, doctorPersona.segundoNombre, doctorPersona.primerApellido, doctorPersona.segundoApellido].filter(Boolean).join(" ") || "",
            histClin: item.consultamedica.cita.paciente.numHistoriaClinica || "",
            especialidad: item.consultamedica.cita.doctor ? item.consultamedica.cita.doctor.especialidad.descripcion : "",
            estadoProceso: item.estadoProceso || "",
            cobertura: tipoCobertura || "",
            tipoCobertura: `${tipoCobertura} ${descCobertura}`,
            medicoRealiza: medicoRealiza,
            msp: mspSubidos
          };
        }
      });

      this.itemspro = procesosMapped;
    },



    viewItem(idAdm) {
      this.$router.push({
        name: "ver_admision",
        params: { id: idAdm },
      });
    },



    onShowModalEjecutar(tokenProceso) {
      this.navigateToQuery("exe", tokenProceso);
    },

    showModalFecha(item) {
      //this.$bvModal.show("modal-editar-fecha");
      const tokenProceso = item.token;
      this.navigateToQuery("setDate", tokenProceso);
    },

    onViewForms(tokenProceso, item) {

      this.dataProc.procedimiento = item?.procedimiento
      this.dataProc.fechaProgramada = item?.fechaprog
      this.dataProc.paciente = item?.paciente
      this.dataProc.estado = item?.estadoProceso
      this.tokenProceso = tokenProceso
      this.navigateToQuery("forms", tokenProceso);
      this.showViewFormsProcesos = true
    },

    onShowModalMSP(tokenProceso) {
      this.navigateToQuery("msp", tokenProceso);
    },


    removeItemid(idAdm) {
      this.fetchRemoveAdmision(idAdm);
    },

    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem("permisos");
      return permisosUsuario.indexOf(permission) !== -1;
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },

    syncFilters() {
      const newValue = this.stFilterProcesos;

      this.filters = {
        search: newValue?.search || null,
        establecimiento: newValue?.establecimiento || null,
        especialidad: newValue?.especialidad || null,
        estado: newValue?.estado || null,
        fechaDesde: newValue?.fechaDesde || null,
        fechaHasta: newValue?.fechaHasta || null,
        excel: newValue?.excel || null,
        observaciones: newValue?.observaciones || null
      }
    }
  },


  watch: {

    stFilterProcesos: {
      deep: true,
      handler(newValue) {
        if (!newValue) return;

        this.syncFilters();
        this.loadDataTable();
      }
    }
  }
};
</script>

<style scoped src="@/assets/css/dropfile.css"></style>
